import FollowUpAgenciamentoConsultPageBase from './FollowUpAgenciamentoConsultPageBase';
import { FOLLOWUP_FILTROS } from '../followUpAgenciamentoFixedFilters';

export default function FollowUpAgenciamentoConsultImportAereoPage(props) {
  return (
    <FollowUpAgenciamentoConsultPageBase
      {...props}
      filtrosFixos={FOLLOWUP_FILTROS.IMPORT_AEREO}
      urlNovo="/importacao/agenciamento/aereo/follow-up/registro/novo"
      urlDetalhes={(id) => `/importacao/agenciamento/aereo/follow-up/${id}/detalhes`}
      urlLista={(id) => `/importacao/agenciamento/aereo/follow-up/${id}/lista`}
      breadcrumbModulo={{
        name: 'Importação Agenciamento Aéreo',
        to: '/importacao/agenciamento/aereo',
      }}
    />
  );
}
